<template>
  <section class="cards-group">
    <div
      class="cards-group__container"
      :class="`cards-group__container--${list[0].element}`"
    >
      <h2
        v-html="list[0].label"
        class="cards-group__title"
        :class="`cards-group__title--${list[0].element}`"
      ></h2>
      <div class="cards-group__labels">
        <span v-for="(item, w) in titles" :key="w" class="cards-group__title">
          {{ item }}
        </span>
      </div>
      <div class="cards-group__vid-block">
        <video
          :poster="list[0].metadata.stitchVideoThumb"
          controls
          autoplay
          disablePictureInPicture
          loop
          controlslist="nodownload"
        >
          <source :src="list[0].metadata.stitchVideo" type="video/mp4" />
        </video>
      </div>
      <div class="cards-group__cards">
        <div
          v-for="(item, x) in list[0].cards"
          :key="x + 5"
          small
          :element="list[0].element"
          :enable-scroll="enableScroll"
          class="cards-group__card"
        >
          <p class="cards-group__body" v-if="item.body" v-html="item.body" />
          <div>
            <button @click="activeModal = item" class="cards-group__btn">
              Expand for larger view
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="list[1] ? list[1].cards : false"
      class="cards-group__container"
      :class="`cards-group__container--${list[1].element}`"
    >
      <h2
        v-html="list[1].label"
        class="cards-group__title"
        :class="`cards-group__title--${list[1].element}`"
      ></h2>
      <div class="cards-group__labels">
        <span v-for="(item, w) in titles" :key="w" class="cards-group__title">
          {{ item }}
        </span>
      </div>
      <div class="cards-group__vid-block">
        <video
          :poster="list[1].metadata.stitchVideoThumb"
          controls
          autoplay
          disablePictureInPicture
          loop
          controlslist="nodownload"
        >
          <source :src="list[1].metadata.stitchVideo" type="video/mp4" />
        </video>
      </div>
      <div class="cards-group__cards">
        <div
          v-for="(item, y) in list[1] ? list[1].cards : false"
          :key="y + 10"
          :title="item.label"
          small
          :element="list[1].element"
          :enable-scroll="enableScroll"
          class="cards-group__card"
        >
          <p class="cards-group__body" v-if="item.body" v-html="item.body" />
          <div>
            <button @click="activeModal = item" class="cards-group__btn">
              Expand for larger view
            </button>
          </div>
        </div>
      </div>
    </div>

    <Modal
      v-if="activeModal"
      @close-modal="activeModal = null"
    >
      <div slot="modal-slot">
        <div class="modal__video-container">
          <video
            :poster="activeModal.thumbnail"
            controls
            autoplay
            disablePictureInPicture
            loop
            controlslist="nodownload"
          >
            <source :src="activeModal.video" type="video/mp4" />
          </video>
        </div>
        <div class="modal__copy" v-html="`${activeModal.body}<br /><br />${activeModal.popup}`"></div>
      </div>
    </Modal>
  </section>
</template>

<script>
import Modal from "../UIComponents/Modal.vue";

export default {
  name: "CardGroup",
  components: {
    Modal,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    enableScroll: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      titles: ["Dopamine", "Norepinephrine", "Serotonin"],
      activeModal: null,
    };
  },
};
</script>

<style lang="scss" scoped>
.cards-group {
  width: 100%;
  margin-top: rem(50);
  height: calc(100% - 90px);
  position: relative;

  &__container {
    border: 1px solid #707070;
    background: $white;
    padding: rem(10);
    margin-bottom: rem(10);

    &--light {
      border-color: #ffce00;
    }

    &--medium {
      border-color: #be5b92;
    }

    &--dark {
      border-color: #006d8a;
    }
  }

  &__title {
    color: #646464;
    font-size: rem(16);
    font-weight: 300;
    margin-bottom: 0;

    &--light {
      color: #ffce00;
    }

    &--medium {
      color: #be5b92;
    }

    &--dark {
      color: #006d8a;
    }
  }

  &__labels {
    display: flex;

    span {
      font-size: rem(13);
      font-weight: 500;
      display: flex;
      justify-content: flex-start;
      width: 33.33%;
    }
  }

  &__vid-block {
    width: 100%;
    margin: 0 auto;
    max-height: rem(145);
    overflow: hidden;

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__cards {
    display: flex;
  }

  &__card {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &__body {
    font-size: rem(10);
    color: #646464;
    margin: rem(5) rem(0);
    padding-right: 1em;
  }

  &__btn {
    border: none;
    background: none;
    border: 1px solid #707070;
    border-radius: 3px;
    color: #707070;
    padding: rem(5) rem(15);
    text-transform: uppercase;
    font-size: rem(10);
  }

  .modal__video-container {
    video {
      width: 100%;
    }
  }

  video::-webkit-media-controls-timeline {
    display: none;
  }
  video::-webkit-media-controls-time-display {
    display: none;
  }
  video::-webkit-media-controls-fullscreen-button {
    display: none;
  }
  video::-webkit-media-controls-volume-slider {
    display: none;
  }
  video::-webkit-media-controls-mute-button {
    display: none;
  }
  video::-webkit-media-controls-timeline {
    display: none;
  }
  video::-webkit-media-controls-current-time-display {
    display: none;
  }
  video::-webkit-media-controls-time-remaining-display {
    display: none;
  }
  video::-webkit-media-controls-panel {
    background-image: linear-gradient(transparent 50%, #646464);
  }

  @include iPadProStyles {
    &__title {
      font-size: rem(20);
    }

    &__labels {
      span {
        font-size: rem(16);
      }
    }

    &__btn {
      font-size: rem(14);
      padding: rem(6) rem(15);
    }

    &__container {
      padding: 15px;
    }

    &__labels span {
      font-size: rem(20);
    }

    &__vid-block {
      max-height: rem(204);
    }

    &__body {
      padding: rem(8) 1em rem(10) 0;
      margin: 0;
      font-size: rem(13);
    }
  }
}
</style>
